import { useTranslation } from "react-i18next";
import textos from "./textos/Servicios.jsx";

// Pàgina "servicios" de l'Hotel Camprodon. Els textos propis de cada idioma
// són a textos/Servicios.jsx; els genèrics, amb t() (Traducciones/lang).
// El comportament (sliders, galeria, formularis...) és a ContenidoHtml.
const Servicios = ({ lang }) => {

    const { t } = useTranslation();
    const tx = textos[lang] ?? textos.es;

    return (
        <>
            <section className="c-hero c-hero--large">
                <div className="c-hero--container" style={{maxHeight: "100vh"}}>
                    <div>
                        <div className="position-relative">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/1920x1036__rcg-hc-faoana-03-1691427022.jpg" alt={tx.heroImageAlt} className="image-cover image-full c-hero__image" width="100%" height="100%" />
                            </picture>
                            <div className="c-hero__content position-relative">
                                <span className="c-hero__small-title text-uppercase">{tx.heroSmallTitle}</span>
                                <h1 className="c-hero__title">{tx.heroTitle}</h1>
                                <span className="line max-line-height">
                                    <svg aria-hidden="true" focusable="false" className="c-icon ico-mouse">
                                        <use href="/images/web/hotelcamprodon/icons-sprite.svg#sprite-icon-ico-mouse-scrolldown"></use>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div id="c-sticky-widget-notifier"></div>
            <section className="c-sticky-widgets d-inline-flex position-relative">
                <div className="c-sticky-widgets--button c-sticky-widgets--booking d-flex-center"><a href={tx.stickyWidgetsButtonHref} className="text-uppercase text-center d-flex-center">{t("Reserva hotel")}</a></div>
                <div className="c-sticky-widgets--button c-sticky-widgets--restaurant d-flex-center"><a href={tx.stickyWidgetsButtonHref2} target="_blank" className="text-uppercase text-center d-flex-center" rel="noopener noreferrer">{t("Reserva restaurante")}</a></div>
            </section>
            <section className="position-relative bg-gray ">
                <div className="c-benefits-slider d-flex-center o-container">
                    <span className="c-benefits-slider__small-title text-uppercase">{t("Ventajas de reservar en el web oficial")}</span>
                    <ul id="draggable-slider" className="c-slider list-style-none m-0 p-0">
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__millor-preu-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Mejor precio garantizado")} />
                            </picture>
                            <div>
                                <span>{t("Mejor precio garantizado")}</span>
                            </div>
                        </li>
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__reserva-segura-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Reserva segura")} />
                            </picture>
                            <div>
                                <span>{t("Reserva segura")}</span>
                            </div>
                        </li>
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__confirmacio-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Confirmación inmediata")} />
                            </picture>
                            <div>
                                <span>{t("Confirmación inmediata")}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
            <section className="c-presentation o-container text-center ">
                <div className="c-presentation__small-title text-uppercase">{tx.presentationSmallTitle}</div>
                <h2 className="c-presentation__title">{tx.presentationTitle}</h2>
                <div className="c-presentation__content">
                    <p>{tx.presentationContent}</p>
                </div>
            </section>
            <section className="c-surroundings-container">
                <div className="c-surroundings c-cards-list c-cards-list--vertical ">
                    <div className="c-surroundings__item ">
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/piscina-i-jardi__309x309__piscina-gente-arboles-hotel-camprodon-1677075022.jpg" className="image-cover c-surroundings__img" width="100%" height="100%" loading="lazy" decoding="async" alt={t("Piscina")} />
                        </picture>
                        <div className="c-surroundings__content d-flex-center-md">
                            <h3 className="c-surroundings--title">{t("Piscina")}</h3>
                            <div className="c-read-more">
                                <div className="c-read-more__content" id="read-more-content-0">
                                    <p>{tx.readMoreContent}</p>
                                    <p>
                                        <em>{tx.readMoreContent2}</em>
                                    </p>
                                </div>
                                <button className="c-read-more__button hc-hidden" id="read-more-button-0"><span data-read-more={t("Leer más")} data-read-less={t("Leer menos")}>{t("Leer más")}</span>{" "}<i className="arrow down"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="c-surroundings__item c-surroundings__item--reverse">
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/piscina-i-jardi__309x309__jardin-cesped-arboles-edificio-hotel-camprodon-1677075022.jpg" alt={tx.surroundingsImgAlt} className="image-cover c-surroundings__img" width="100%" height="100%" loading="lazy" decoding="async" />
                        </picture>
                        <div className="c-surroundings__content d-flex-center-md">
                            <h3 className="c-surroundings--title">{tx.surroundingsTitle}</h3>
                            <div className="c-read-more">
                                <div className="c-read-more__content" id="read-more-content-1">
                                    <p>{tx.readMoreContent3}</p>
                                    <p>{tx.readMoreContent4}</p>
                                </div>
                                <button className="c-read-more__button hc-hidden" id="read-more-button-1"><span data-read-more={t("Leer más")} data-read-less={t("Leer menos")}>{t("Leer más")}</span>{" "}<i className="arrow down"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="c-surroundings__item ">
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/restaurant-i-esmorzars__309x309__mesas-sillas-desayuno-buffet-hotel-camprodon-1677075050.jpg" alt={tx.surroundingsImgAlt2} className="image-cover c-surroundings__img" width="100%" height="100%" loading="lazy" decoding="async" />
                        </picture>
                        <div className="c-surroundings__content d-flex-center-md">
                            <h3 className="c-surroundings--title">{tx.surroundingsTitle2}</h3>
                            <div className="c-read-more">
                                <div className="c-read-more__content" id="read-more-content-2">
                                    <p>{tx.readMoreContent5}</p>
                                    <p>{tx.readMoreContent6}</p>
                                    <p>
                                        <em>{tx.readMoreContent7}</em>
                                    </p>
                                </div>
                                <button className="c-read-more__button hc-hidden" id="read-more-button-2"><span data-read-more={t("Leer más")} data-read-less={t("Leer menos")}>{t("Leer más")}</span>{" "}<i className="arrow down"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="c-surroundings__item c-surroundings__item--reverse">
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/demo__309x309__puzzle-mano-hotel-camprodon-1678981829.jpg" className="image-cover c-surroundings__img" width="100%" height="100%" loading="lazy" decoding="async" alt={t("Sala de juegos")} />
                        </picture>
                        <div className="c-surroundings__content d-flex-center-md">
                            <h3 className="c-surroundings--title">{t("Sala de juegos")}</h3>
                            <div className="c-read-more">
                                <div className="c-read-more__content" id="read-more-content-3">
                                    <p>{tx.readMoreContent8}</p>
                                    <p>{tx.readMoreContent9}</p>
                                </div>
                                <button className="c-read-more__button hc-hidden" id="read-more-button-3"><span data-read-more={t("Leer más")} data-read-less={t("Leer menos")}>{t("Leer más")}</span>{" "}<i className="arrow down"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="c-surroundings__item ">
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/demo__309x309__libro-mano-manta-hotel-camprodon-1678981828.jpg" alt={tx.surroundingsImgAlt3} className="image-cover c-surroundings__img" width="100%" height="100%" loading="lazy" decoding="async" />
                        </picture>
                        <div className="c-surroundings__content d-flex-center-md">
                            <h3 className="c-surroundings--title">{tx.surroundingsTitle3}</h3>
                            <div className="c-read-more">
                                <div className="c-read-more__content" id="read-more-content-4">
                                    <p>{tx.readMoreContent10}</p>
                                </div>
                                <button className="c-read-more__button hc-hidden" id="read-more-button-4"><span data-read-more={t("Leer más")} data-read-less={t("Leer menos")}>{t("Leer más")}</span>{" "}<i className="arrow down"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="c-surroundings__item c-surroundings__item--reverse">
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/demo__309x309__pared-senal-parquing-hotel-camprodon-1678981829.jpg" alt={tx.surroundingsImgAlt4} className="image-cover c-surroundings__img" width="100%" height="100%" loading="lazy" decoding="async" />
                        </picture>
                        <div className="c-surroundings__content d-flex-center-md">
                            <h3 className="c-surroundings--title">{tx.surroundingsTitle4}</h3>
                            <div className="c-read-more">
                                <div className="c-read-more__content" id="read-more-content-5">
                                    <p>{tx.readMoreContent11}</p>
                                    <p>{tx.readMoreContent12}</p>
                                    <p>{tx.readMoreContent13}</p>
                                </div>
                                <button className="c-read-more__button hc-hidden" id="read-more-button-5"><span data-read-more={t("Leer más")} data-read-less={t("Leer menos")}>{t("Leer más")}</span>{" "}<i className="arrow down"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="c-surroundings__item ">
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/demo__309x309__caja-fuerte-hotel-camprodon-1678981828.jpeg" className="image-cover c-surroundings__img" width="100%" height="100%" loading="lazy" decoding="async" alt={t("Caja fuerte")} />
                        </picture>
                        <div className="c-surroundings__content d-flex-center-md">
                            <h3 className="c-surroundings--title">{t("Caja fuerte")}</h3>
                            <div className="c-read-more">
                                <div className="c-read-more__content" id="read-more-content-6">
                                    <p>{tx.readMoreContent14}</p>
                                    <p>{tx.readMoreContent15}</p>
                                </div>
                                <button className="c-read-more__button hc-hidden" id="read-more-button-6"><span data-read-more={t("Leer más")} data-read-less={t("Leer menos")}>{t("Leer más")}</span>{" "}<i className="arrow down"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Servicios;
